// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","color-black":"#000000","colorBlack":"#000000","box":"xySF2","count":"EDVVi"};